import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTooltip } from 'vuetify/lib/components/VTooltip';

var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "min-w-0 w-full" },
    [
      _vm.items.length == 0
        ? _c("StateComponent", {
            attrs: {
              state: "empty_state",
              title: _vm.$t("my_objects.states_objects.no_access"),
              subtitle: _vm.$t("my_objects.states_objects.no_access_subtitle"),
            },
          })
        : _c(
            VCard,
            [
              _c(VDataTable, {
                staticClass: "text-center table-inca",
                attrs: {
                  id: "table-access",
                  responsive: "",
                  hover: "",
                  items: _vm.serverItems,
                  headers: _vm.tableFields,
                  "hide-default-footer": true,
                  "sort-by": ["permissionExpirationDate"],
                  "sort-desc": [true],
                  loading: _vm.loadingPage,
                },
                scopedSlots: _vm._u([
                  {
                    key: "item.table.id",
                    fn: function (ref) {
                      var item = ref.item
                      return [
                        _c("div", { staticClass: "text-left" }, [
                          _c("b", [
                            _c(
                              "a",
                              {
                                staticClass: "table-name",
                                on: {
                                  click: function ($event) {
                                    return _vm.openModalEdit(
                                      item,
                                      _vm.MODAL_NAME_METADATA_VIEW
                                    )
                                  },
                                },
                              },
                              [
                                _c("span", [
                                  _vm._v(_vm._s(item.table.objectId)),
                                ]),
                              ]
                            ),
                          ]),
                          _c("br"),
                          _c(
                            "a",
                            {
                              staticClass: "compose-name",
                              attrs: { title: item.id },
                              on: {
                                click: function ($event) {
                                  return _vm.openModalEdit(
                                    item,
                                    _vm.MODAL_NAME_METADATA_VIEW
                                  )
                                },
                              },
                            },
                            [
                              _c("span", { staticClass: "caption" }, [
                                _vm._v(_vm._s(item.table.id)),
                              ]),
                            ]
                          ),
                        ]),
                      ]
                    },
                  },
                  {
                    key: "item.columns",
                    fn: function (ref) {
                      var item = ref.item
                      return [
                        _c(
                          "span",
                          {
                            directives: [
                              {
                                name: "b-popover",
                                rawName: "v-b-popover.hover.bottom",
                                value: item.columns_change
                                  ? "One or more columns were changed or added!"
                                  : "",
                                expression:
                                  "item.columns_change ? 'One or more columns were changed or added!':''",
                                modifiers: { hover: true, bottom: true },
                              },
                            ],
                            class: _vm.classColumnsChange(item),
                          },
                          [_vm._v(_vm._s(item.columns || 0))]
                        ),
                      ]
                    },
                  },
                  {
                    key: "item.numRows",
                    fn: function (ref) {
                      var item = ref.item
                      return [
                        item.numRows
                          ? _c("span", [
                              _vm._v(
                                _vm._s(
                                  _vm._f("formatCurrency")(
                                    Number.parseInt(item.numRows),
                                    {
                                      decimalDigits: 0,
                                      decimalSeparator: ".",
                                      thousandsSeparator: ",",
                                      currencySymbolNumberOfSpaces: 0,
                                      currencySymbolPosition: "left",
                                    }
                                  )
                                )
                              ),
                            ])
                          : _c(
                              "span",
                              [
                                _c(VProgressCircular, {
                                  attrs: {
                                    size: 20,
                                    indeterminate: "",
                                    color: "primary",
                                  },
                                }),
                              ],
                              1
                            ),
                      ]
                    },
                  },
                  {
                    key: "item.permissionExpirationDate",
                    fn: function (ref) {
                      var item = ref.item
                      return [
                        _c("span", { class: _vm.classExpirationDate(item) }, [
                          _vm._v(_vm._s(item.permissionExpirationDate)),
                        ]),
                      ]
                    },
                  },
                  {
                    key: "item.actions",
                    fn: function (ref) {
                      var item = ref.item
                      return [
                        _c(
                          VTooltip,
                          {
                            attrs: { bottom: "" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "activator",
                                  fn: function (ref) {
                                    var on = ref.on
                                    var attrs = ref.attrs
                                    return [
                                      _c(
                                        VBtn,
                                        _vm._g(
                                          _vm._b(
                                            {
                                              staticClass: "btn-icon-inca",
                                              attrs: { icon: "", small: "" },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.openModalEdit(
                                                    item,
                                                    _vm.MODAL_NAME_METADATA
                                                  )
                                                },
                                              },
                                            },
                                            "v-btn",
                                            attrs,
                                            false
                                          ),
                                          on
                                        ),
                                        [
                                          _c(
                                            VIcon,
                                            { attrs: { small: "" } },
                                            [_vm._v("icon-edit")]
                                          ),
                                        ],
                                        1
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              true
                            ),
                          },
                          [
                            _c("span", [
                              _vm._v(
                                _vm._s(_vm.$t("my_objects.update_metadata"))
                              ),
                            ]),
                          ]
                        ),
                        _c(
                          VMenu,
                          {
                            attrs: {
                              "offset-x": "",
                              "nudge-width": 300,
                              "close-on-content-click": false,
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "activator",
                                  fn: function (ref) {
                                    var menu = ref.on
                                    var attrs = ref.attrs
                                    return [
                                      _c(
                                        VTooltip,
                                        {
                                          attrs: { bottom: "" },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "activator",
                                                fn: function (ref) {
                                                  var tooltip = ref.on
                                                  return [
                                                    item.days_to_expire >= 0
                                                      ? _c(
                                                          VBtn,
                                                          _vm._g(
                                                            _vm._b(
                                                              {
                                                                staticClass:
                                                                  "btn-icon-inca",
                                                                attrs: {
                                                                  small: "",
                                                                  icon: "",
                                                                },
                                                              },
                                                              "v-btn",
                                                              attrs,
                                                              false
                                                            ),
                                                            Object.assign(
                                                              {},
                                                              tooltip,
                                                              menu
                                                            )
                                                          ),
                                                          [
                                                            _c(
                                                              VIcon,
                                                              {
                                                                attrs: {
                                                                  small: "",
                                                                },
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "icon-view"
                                                                ),
                                                              ]
                                                            ),
                                                          ],
                                                          1
                                                        )
                                                      : _vm._e(),
                                                  ]
                                                },
                                              },
                                            ],
                                            null,
                                            true
                                          ),
                                        },
                                        [
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                item.source == "synapse"
                                                  ? "Ver en Synapse"
                                                  : _vm.$t(
                                                      "my_objects.bigquery"
                                                    )
                                              )
                                            ),
                                          ]),
                                        ]
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              true
                            ),
                          },
                          [
                            _c(
                              VCard,
                              [
                                _c(VCardTitle, { staticClass: "pa-1" }, [
                                  _vm._v(
                                    _vm._s(
                                      item.source == "synapse"
                                        ? "Ver en Synapse"
                                        : _vm.$t("my_objects.bigquery")
                                    )
                                  ),
                                ]),
                                _c(
                                  VCardText,
                                  { staticClass: "pa-1" },
                                  [
                                    _c(VTextField, {
                                      attrs: {
                                        dense: "",
                                        filled: "",
                                        readonly: "",
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "append-outer",
                                            fn: function () {
                                              return [
                                                _c(
                                                  VBtn,
                                                  {
                                                    attrs: { icon: "" },
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.copyAccessLink(
                                                          item.view_url
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      VIcon,
                                                      { attrs: { small: "" } },
                                                      [_vm._v("icon-copy")]
                                                    ),
                                                  ],
                                                  1
                                                ),
                                                _c(
                                                  VBtn,
                                                  {
                                                    attrs: { icon: "" },
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.generateViewUrl(
                                                          item
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      VIcon,
                                                      { attrs: { small: "" } },
                                                      [_vm._v("icon-view")]
                                                    ),
                                                  ],
                                                  1
                                                ),
                                              ]
                                            },
                                            proxy: true,
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                      model: {
                                        value: item.view_url,
                                        callback: function ($$v) {
                                          _vm.$set(item, "view_url", $$v)
                                        },
                                        expression: "item.view_url",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          VTooltip,
                          {
                            attrs: { bottom: "" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "activator",
                                  fn: function (ref) {
                                    var on = ref.on
                                    var attrs = ref.attrs
                                    return [
                                      _c(
                                        VBtn,
                                        _vm._g(
                                          _vm._b(
                                            {
                                              staticClass: "btn-icon-inca",
                                              attrs: { icon: "", small: "" },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.copyviewid(
                                                    item.view.id
                                                  )
                                                },
                                              },
                                            },
                                            "v-btn",
                                            attrs,
                                            false
                                          ),
                                          on
                                        ),
                                        [
                                          _c(
                                            VIcon,
                                            { attrs: { small: "" } },
                                            [_vm._v("icon-copy")]
                                          ),
                                        ],
                                        1
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              true
                            ),
                          },
                          [
                            _c("span", [
                              _vm._v(_vm._s(_vm.$t("my_objects.copy_view"))),
                            ]),
                          ]
                        ),
                        _c(
                          VTooltip,
                          {
                            attrs: { bottom: "" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "activator",
                                  fn: function (ref) {
                                    var on = ref.on
                                    var attrs = ref.attrs
                                    return [
                                      item.days_to_expire <= 0 ||
                                      item.days_to_expire <= 7 ||
                                      item.columns_change
                                        ? _c(
                                            VBtn,
                                            _vm._g(
                                              _vm._b(
                                                {
                                                  staticClass: "btn-icon-inca",
                                                  attrs: {
                                                    icon: "",
                                                    small: "",
                                                  },
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.openModalEdit(
                                                        item,
                                                        _vm.MODAL_REQUEST_ACCESS
                                                      )
                                                    },
                                                  },
                                                },
                                                "v-btn",
                                                attrs,
                                                false
                                              ),
                                              on
                                            ),
                                            [
                                              _c(
                                                VIcon,
                                                { attrs: { small: "" } },
                                                [_vm._v("mdi-key-outline")]
                                              ),
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                    ]
                                  },
                                },
                              ],
                              null,
                              true
                            ),
                          },
                          [
                            _c("span", [
                              _vm._v(
                                _vm._s(_vm.$t("my_objects.request_access"))
                              ),
                            ]),
                          ]
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
      _c("pagination-firestore", {
        key: _vm.key_pagination,
        attrs: { pagination: _vm.pagination, pageType: "1" },
        on: { changePagina: _vm.changePage },
      }),
      _c(
        "dialogs-component",
        {
          ref: "dialogMetadata",
          attrs: {
            title: _vm.$t("my_objects.metadata"),
            width: 1200,
            showButtons: true,
          },
        },
        [
          _c(
            "template",
            { slot: "body" },
            [
              _c("form-metadata-table-component", {
                ref: "viewmetadataTableRef",
                attrs: {
                  tplToWork: _vm.tplToUpdate,
                  isChangeRequest: _vm.TYPE_CHANGE_METADA.VIEWER_ONLY,
                  lazyLoadParams: _vm.lazyLoadParamsForViewer,
                },
                on: {
                  submit: function ($event) {
                    return _vm.$refs[_vm.MODAL_NAME_METADATA_VIEW].onClose()
                  },
                  cancel: function ($event) {
                    return _vm.$refs[_vm.MODAL_NAME_METADATA_VIEW].onClose()
                  },
                },
              }),
            ],
            1
          ),
          _c(
            "template",
            { slot: "btnsLeft" },
            [
              _c(
                VBtn,
                {
                  attrs: { color: "secondary", outlined: "" },
                  on: {
                    click: function ($event) {
                      return _vm.$refs.viewmetadataTableRef.clickDownloadCSV()
                    },
                  },
                },
                [
                  _c(VIcon, [_vm._v("icon-download")]),
                  _vm._v(_vm._s(_vm.$t("btns.download_metadata"))),
                ],
                1
              ),
            ],
            1
          ),
        ],
        2
      ),
      _c(
        "dialogs-component",
        {
          ref: "dialogMetadataChange",
          attrs: {
            title: _vm.$t("my_objects.update_metadata"),
            width: 1200,
            showButtons: true,
          },
        },
        [
          _c(
            "template",
            { slot: "body" },
            [
              _c("form-metadata-table-component", {
                ref: "metadataTableRef",
                attrs: {
                  tplToWork: _vm.tplToUpdate,
                  isChangeRequest: _vm.TYPE_CHANGE_METADA.CHANGE_REQUEST,
                },
                on: {
                  submit: function ($event) {
                    return _vm.$refs["dialogMetadataChange"].onClose()
                  },
                  cancel: function ($event) {
                    return _vm.$refs["dialogMetadataChange"].onclose()
                  },
                },
              }),
            ],
            1
          ),
          _c(
            "template",
            { slot: "btnsLeft" },
            [
              _c(
                VBtn,
                {
                  attrs: { color: "secondary", outlined: "" },
                  on: {
                    click: function ($event) {
                      return _vm.$refs.metadataTableRef.clickDownloadCSV()
                    },
                  },
                },
                [
                  _c(VIcon, [_vm._v("icon-download")]),
                  _vm._v(_vm._s(_vm.$t("btns.download_metadata"))),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "template",
            { slot: "btnsRight" },
            [
              _c(
                VBtn,
                {
                  attrs: { color: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.$refs.metadataTableRef.validateForm(
                        "ok",
                        $event
                      )
                    },
                  },
                },
                [
                  _c(VIcon, { attrs: { small: "" } }, [_vm._v("icon-send")]),
                  _vm._v(_vm._s(_vm.$t("btns.request"))),
                ],
                1
              ),
            ],
            1
          ),
        ],
        2
      ),
      _c(
        "dialogs-component",
        {
          ref: _vm.MODAL_REQUEST_ACCESS,
          attrs: {
            title: _vm.$t("my_objects.request_access"),
            width: 1200,
            showButtons: true,
          },
        },
        [
          _c(
            "template",
            { slot: "body" },
            [
              _c("form-access-request-table-component", {
                ref: "requestFormRef",
                attrs: { tplToWork: _vm.tplToUpdate },
                on: {
                  submit: _vm.sendRequest,
                  cancel: function ($event) {
                    return _vm.$refs[_vm.MODAL_REQUEST_ACCESS].onClose()
                  },
                },
              }),
            ],
            1
          ),
          _c(
            "template",
            { slot: "btnsRight" },
            [
              _c(
                VBtn,
                {
                  attrs: { color: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.$refs.requestFormRef.onSubmit($event)
                    },
                  },
                },
                [
                  _c(VIcon, { attrs: { small: "" } }, [_vm._v("icon-send")]),
                  _vm._v(_vm._s(_vm.$t("btns.request"))),
                ],
                1
              ),
            ],
            1
          ),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }